// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3o3-J","placeholdersHeader":"styles_placeholdersHeader__8BIez","editorStyle":"styles_editorStyle__3JcLy","placeholdersBox":"styles_placeholdersBox__aTBCy"};